import {
  AxiosPost,
  AxiosGet,
  AxiosDelete,
} from "../../helpers/microserviceAPIs"
import { housingApiUrl } from "../../config/microservicesUrls"

const api_url = housingApiUrl()

export async function housingApiListHousesPost(
  jwt,
  enterpriseId,
  organizationId,
  pageSize,
  pageNum,
  searchPhrase
) {
  const body = {
    enterpriseId: enterpriseId,
    organizationId: organizationId,
    pageSize: pageSize,
    pageNum: pageNum,
    searchPhrase: searchPhrase,
  }

  return await AxiosPost(jwt, `${api_url}/api/House/List`, body)
}

export async function housingApiCreateHousePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/House/Create`, body)
}

export async function housingApiGetHouseGet(jwt, houseId) {
  return await AxiosGet(jwt, `${api_url}/api/House/${houseId}`)
}

export async function housingApiGetHousePastOccupationPost(
  jwt,
  houseId,
  roomId,
  body
) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/House/${houseId}/${roomId}/PastOccupants`,
    body
  )
}

export async function housingApiUpdateHousePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/House/Update`, body)
}

export async function housingApiDeleteHouseDelete(jwt, body) {
  return await AxiosDelete(jwt, `${api_url}/api/House`, body)
}

export async function housingApiUploadHouseImagePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/House/uploadImage`, body)
}

export async function housingApiAssignBedOccupancyPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Bed/Assign`, body)
}

export async function housingApiRemoveBedOccupancyPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Bed/Remove`, body)
}

export async function housingApiAssignBedOccupancyListPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Bed/ListAssignments`, body)
}

export async function housingApiListActivitiesPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Activity/list`, body)
}

export async function housingApiCreateActivityPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Activity/create`, body)
}

export async function housingApiEditActivityPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Activity/update`, body)
}

export async function housingApiListRentPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/rent/listRent`, body)
}

export async function housingApiCreateRentPaymentPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/rent/payment`, body)
}

export async function housingApiCreateUserChargePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/rent/createUserCharge`, body)
}

export async function housingApiEditUserChargePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/rent/editUserCharge`, body)
}

export async function housingApiRemoveUserChargePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/rent/removeUserCharge`, body)
}

export async function housingApiCreateUserChargePaymentPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/rent/userChargePayment`, body)
}

export async function housingApiListNotesPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Participant/listNotes`, body)
}

export async function housingApiCreateNotePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Participant/createNote`, body)
}

export async function housingApiEditNotePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Participant/editNote`, body)
}

export async function housingApiRemoveNotePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Participant/removeNote`, body)
}
